import request from "../utils/request";

export const getSalesOrder = '/sales/order/';

export function getSalesOrderDetail(id: number | string) {
    return request.get('/sales/order/detail', {params: {orderId: id}});
}

export function saveSalesOrder(values: any) {
    return request.post('/sales/order/modifySaleOrder', values);
}

export function saveSalesOrderRemark(values: any) {
    return request.post('/sales/order/remark', {
        id: values.id,
        remark: values.remark
    });
}

export function completeSalesOrder(values: any) {
    return request.post('/sales/order/complete', values);
}

export function submitSalesOrder(id: number, rebate = false, forceOption={force:false,restrictForce:false}) {
    return request.post('/sales/order/submit', {orderId: id, rebate, ...forceOption});
}

export function adminSubmitSalesOrder(orderId: any) {
    return request.post('/sales/order/admin/submit', {orderId});
}

export function modifyGiveaway(params: any) {
    return request.post('/sales/order/giveaway', params);
}

export function getExpectShippingCost(orderId: number, expressId: number) {
    return request.get('/sales/order/prediction/freight', {params: {orderId, expressId}});
}

export function modifyShippingCost(params: any) {
    return request.post('/sales/order/freight', params);
}

export function modifyOrderType(params: any) {
    return request.post('/sales/order/orderType', params);
}

export function oaSend(params: any) {
    return request.request({method: "post", url: "/sales/order/oa", data: params})
}

export function oaComplete(params: any) {
    return request.request({method: "post", url: "/sales/order/oa/complete", data: params})
}

export function specialApprovalConfirm(orderId: number) {
    return request.request({method: "get", url: "/sales/order/specialApprovalConfirm", params: {orderId: orderId}})
}

export function erpSync(orderId: number) {
    return request.request({method: "get", url: "/sales/order/syncErp", params: {orderId: orderId}})
}

export function getOrderWriteOff(orderId: number) {
    return request.request({method: "get", url: "/sales/order/writeOff", params: {orderId: orderId}})
}

export function getQualityInspectionReport(orderId: number) {
    return request.request({method: "get", url: "/qualification/sales/order", params: {orderId: orderId}})
}

export function getOrderExpress(orderId: number) {
    return request.request({method: "get", url: "/sales/order/express", params: {orderId: orderId}})
}


export function closeOrder(orderId: any) {
    return request.put('/sales/order/close', {orderId})
}

export function contactOrder(params: any) {
    return request.post('/sales/order/contact', params);
}

export function copyOrder(orderId: any) {
    return request.post('/sales/order/copy', {orderId});
}

export function copyOrderFull(orderId: any) {
    return request.post('/sales/order/copy/full', {orderId});
}

export function deleteOrder(orderId: any) {
    return request.delete('/sales/order/', {params: {orderId}});
}

export function overDueOrder(orderId: any) {
    return request.post('/sales/order/overdue', {orderId});
}

export function addSamples(orderId: any, samples: Array<any>) {
    return request.post('/sales/order/sample', {orderId, samples});
}

export function updateContract(orderId: any, contractId: any) {
    return request.post('/sales/order/contract', {orderId, contractId});
}


export const exportOrderUrl = '/sales/order/exportSalesOrder';
